import { render, staticRenderFns } from "./CallsPerDays.vue?vue&type=template&id=2dd74b74&scoped=true"
import script from "./CallsPerDays.vue?vue&type=script&lang=js"
export * from "./CallsPerDays.vue?vue&type=script&lang=js"
import style0 from "./CallsPerDays.vue?vue&type=style&index=0&id=2dd74b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd74b74",
  null
  
)

export default component.exports